export default {
  // Proprety  根据ID修改经纬度
  getPropertyUpdate: "propertyManagement/prop/update",
  //gl acct
  glAccount: "/glAcct/search",
  // Approval request Recore Only
  getApprovalRequestRecore: "/approval/recordOnly",
  // 获取单个PDF 数据
  getPDFFile: "/file/getFile",
  // id,Type获取可查看文件的内容
  getFilePaths: "/file/getFilePaths",
  // 字典
  getDictionary: "/Dict/payBy",
  // Payment文件查看
  fileDetailsPayment: "/file/fileDetailsPayment",
  // 点击账单金额显示详情
  commonShowPayment: "/common/showPayment",
  // 权限点击次数
  commonSubmitCount: "/common/submit/count",
  // bank  数据查询
  getBackDictList: "/common/getBankDict",
  // trust 数据查询
  getTrustDictList: "/common/getTrustDict",
  // company 数据查询
  getCompanyDictList: "/common/getCompanyDict",
  // glAcct 数据查询
  getAcctDictList: "/common/showGlAcctById",
  // 州  数据查询
  getStateDictList: "/common/getStateDict",
  // owner 数据查询
  getOwnerDictList: "/common/getOwnerList",
  // group下拉框
  commonGroupList: "/common/groupList",
  //获取owner 列表
  // getOwnerList:"/dashboard/operatingStatement/showOwnerVo",
  getOwnerDictList_2: "/common/getOwnerVoList",
  // bank - 获取trust 数据
  getTrustDictList_2: "/common/getOwnerTrustDict",
  // 文件上传
  getUpdateFileDict: "/file/uploadFile",
  // Supervisor列表
  getSupervisorDict: "/common/getSupervisorDict",
  // Standard supervisor options with formatted, alphabetically sorted full names.
  getSupervisorSOList: "/common/supervisor/getSupervisorSOList",
  // Supervisor列表去重
  getSupervisorNameDict: "/common/getSupervisorNameDict",
  // 获取系统时间
  commonCurrentDate: "/common/currentDate",
  // 获取系统到下个月1号的时间
  commonNextDate: "/common/nextDate",
  // 获取PropType数据
  getPropTypeList: "/common/getPropTypeList",
  // 返回base64格式时编辑时删除文件
  commonDelFiles: "/file/delFiles",
  // t bank检索
  getBankListDict: "/common/getBankByTrustId",
  //获取时间周期
  getDateRanges:"/common/generateDateRanges",
  // 通过propid，acctType类型，是否再用来返回glAcct
  // showGlAcctByChartNameId: "/common/showGlAcctByChartNameId",
    showGlAcctByChartNameId: "/common/showGlAcctByPropId",
  // 获取unit 
  getUnitTypeList:"/common/unitType",
  // 获取GLChart 映射字段
  getFieldMapping:"/common/glAcct/getFieldMapping",
  // 通过glChartNameId获取glAcct数据
  getGlAcctSOListByNameId:"/common/glAcct/getGlAcctSOListByNameId",
  // propbytrustid
  getPropByTrustList:"/common/propByTrustIdDict",
    // glAcctByPropldList
  glAcctByPropIdList: "/common/glAcctByPropId",
  // 根据propId 查询GLAcct
  getShowGlAcctByProp:"/common/showGlAcctByPropId",
  // 查询GLActt -批量
  getShowGlAcctByPropList:"/common/showGlAcctByGlChartNameId",
  // 查询GLActt -批量
  getDateRange: "/common/dateRange",
};
